import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectConfigValue } from '../../../selectors/config';
import { useStateWithHistory } from '../../../utils';
import { EContainerTypes } from '../types';
import { IDealSaleOfferLabelContext } from '../utils/formContext';
import { getInitialStep } from '../utils/getInitialStep';
import { ELabelActionsType, useGetLabelActions } from './useGetLabelActions';

export const useDealSaleOfferLabelState = () => {
  const getE2eLabelResponse = useSelector(selectConfigValue('e2eLabelResponse'));
  const [containerType, setContainerType, containerTypeHistory] = useStateWithHistory<EContainerTypes>(
    getInitialStep(getE2eLabelResponse),
    1,
  );
  const actionsMap = useGetLabelActions(containerType);

  const formContextValue = React.useMemo<IDealSaleOfferLabelContext>(() => {
    const actionFabric = (actionValue?: EContainerTypes) => {
      if (actionValue) {
        return () => setContainerType(actionValue);
      }

      return undefined;
    };

    return {
      previousStep: containerTypeHistory[0],
      onStepYes: actionFabric(actionsMap[ELabelActionsType.StepYes]),
      onStepNo: actionFabric(actionsMap[ELabelActionsType.StepNo]),

      onPreviousStep: () => {
        const previousContainer = containerTypeHistory[0];

        /* istanbul ignore next - только для дева */
        if (!previousContainer) {
          throw new Error('Could not find previous container. Going back too early?');
        }
        setContainerType(previousContainer);
      },

      onClose: () => {
        setContainerType(EContainerTypes.NullContainer);
      },
    };
  }, [actionsMap, containerTypeHistory, setContainerType]);

  return {
    containerType,
    formContextValue,
  };
};
